import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export default class PerformanceLogsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getProcessFrequency(paramsData: any): Promise<any> {
    let querystring = {};
    if (Object.entries(paramsData).length > 0) {
      querystring = this.encodeQueryData({
        start_date: paramsData['start_date'] ? paramsData['start_date'] : '',
        end_date: paramsData['end_date'] ? paramsData['end_date'] : '',
        time_bucket: paramsData['time_bucket'] ? paramsData['time_bucket'] : '',
      });
    }
    return super.get(api.get_process_frequency + '?' + querystring, {});
  }

  public async getServiceMetricsSummary(paramsData: any): Promise<any> {
    let querystring = {};
    if (Object.entries(paramsData).length > 0) {
      querystring = this.encodeQueryData({
        start_date: paramsData['start_date'] ? paramsData['start_date'] : '',
        end_date: paramsData['end_date'] ? paramsData['end_date'] : '',
      });
    }
    return super.get(api.get_service_metrics_summary + '?' + querystring, {});
  }

  public async getStatusMetricsSummary(paramsData: any): Promise<any> {
    let querystring = {};
    if (Object.entries(paramsData).length > 0) {
      querystring = this.encodeQueryData({
        start_date: paramsData['start_date'] ? paramsData['start_date'] : '',
        end_date: paramsData['end_date'] ? paramsData['end_date'] : '',
        enable_all_orgs: paramsData['include_all_orgs'] ? true : false,
      });
    }
    return super.get(api.get_status_metrics_summary + '?' + querystring, {});
  }

  public async gteAvgIdleTimeBuService(): Promise<any> {
    return super.get(api.get_avg_idle_time_by_service);
  }
}
